import React, { Component } from 'react';
import { ErrorMessage } from 'formik';
import ThumbNail from './ThumbNail';
import { imageTypes, uploadMultipleFileOnServer } from '../../../../common/utils/fileUploadUtils';

class MultiImageUploadField extends Component {
  imageFieldValidate = (value) => {
    const { required, validation } = this.props.field;
    const { min, max, regex } = validation;
    let error;
    if (required && !value) {
      error = 'This field is required';
    } else if (!(min && value.length >= min)) {
      error = `Must be ${min} characters. Currently at ${value.length} characters `;
    } else if (!(max && value.length <= max)) {
      error = `Must be at least ${max} characters. Currently at ${value.length} characters `;
    }

    return error;
  };
  maxSelectFile = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 3) {
      const msg = 'Only 3 images can be uploaded at a time';
      event.target.value = null; // discard selected file
      console.log(msg);
      return false;
    }
    return true;
  };
  checkMimeType = (event) => {
    let files = event.target.files;
    let err = '';
    for (var x = 0; x < files.length; x++) {
      if (imageTypes.every((type) => files[x].type !== type)) {
        err += files[x].type + ' is not a supported format\n';
      }
    }
    if (err !== '') {
      event.target.value = null; // discard selected file
      return false;
    }
    return true;
  };

  checkFileSize = (event) => {
    let files = event.target.files;
    let size = 15000;
    let err = '';
    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err += files[x].type + 'is too large, please pick a smaller file\n';
      }
    }
    if (err !== '') {
      event.target.value = null;
      return false;
    }

    return true;
  };

  uploadFile = (event) => {
    const { setFieldValue, field, collectionId, projectId, setSubmitting, version, plugins } =
      this.props;
    uploadMultipleFileOnServer(
      event,
      setFieldValue,
      field,
      collectionId,
      projectId,
      version,
      plugins,
      setSubmitting,
    );
  };

  render() {
    const { field, isConstructorForm } = this.props;
    let imagesArr = this.props.values[field.fieldName];
    return (
      <div className="">
        <input
          type={'file'}
          multiple
          name={field.fieldName}
          className="form-control"
          onChange={this.uploadFile}
          required={!isConstructorForm && field.required}
        />
        {imagesArr ? imagesArr.map((e) => <ThumbNail key={e.uuid} file={e} />) : ''}
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </div>
    );
  }
}

export default MultiImageUploadField;
